/**
 * Merge roster members into a data-athlete list so newly-created users
 * (who have no wearable data yet) still appear with placeholder values.
 */
export function mergeRosterIntoData(dataAthletes: any[], roster: any[], useUnifiedData: boolean): any[] {
    if (roster.length === 0) return dataAthletes;
    const dataById = new Map<number, any>();
    for (const a of dataAthletes) {
        const id = useUnifiedData ? a.id : a.athlete_id;
        if (id != null) dataById.set(id, a);
    }
    const merged = [...dataAthletes];
    for (const member of roster) {
        if (!dataById.has(member.id)) {
            const displayName = [member.first_name, member.last_name].filter(Boolean).join(' ')
                || member.username || `User ${member.id}`;
            if (useUnifiedData) {
                merged.push({
                    id: member.id,
                    name: displayName,
                    score: 0, tier: 'NO_DATA',
                    whoop_connected: false, garmin_connected: false, coros_connected: false,
                    hrv: { value: 0, trend: 0, average: 0, latest: 0, consistency: 0 },
                    rhr: { value: 0, trend: 0 },
                    recovery: { average: 0, latest: 0, trend: 0, data_points: 0 },
                    sleep: { average_duration: 0, latest_duration: 0, average_quality: 0, latest_quality: 0, average_efficiency: 0, data_points: 0 },
                    strain: { average: 0, latest: 0, total: 0, data_points: 0 },
                });
            } else {
                merged.push({
                    athlete_id: member.id,
                    athlete_name: displayName,
                    whoop_connected: false, garmin_connected: false,
                    recovery_data: [],
                });
            }
        }
    }
    return merged;
}
